import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-xs uppercase tracking-[0.28em] text-amber-300 flex items-center gap-3">
    <span className="h-px w-10 bg-amber-300/60" />
    {children}
  </p>
);

export const SectionTitle = ({ lines, testId }) => (
  <h2 data-testid={testId} className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-slate-50 mt-5">
    {lines[0]}
    <br />
    <em className="text-gold">{lines[1]}</em>
  </h2>
);
